import React from "react";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";


const VideoCard = (props) => {
  const history = useHistory();
  const handleClick = () => {
    history.push({
      pathname: `/video-player/${props.id}`,
      state: { videoLink: props.videoLink, genre: props.genre, title: props.title, contentRating: props.contentRating, viewCount: props.viewCount }
    });
  };

  return (
    <Card className="video-tile-link video-tile" style={{cursor:"pointer"}} onClick={handleClick}>
      <CardMedia
        component="img"
        image={props.imgLink}
        height="180"
        alt="Thumbnail"
      />

      <CardContent style={{ backgroundColor: "#181818", color: "white", textDecoration: "none" }}>
        <Typography color="text.secondary">{props.genre}</Typography>
        <Typography gutterBottom variant="h5">
          {props.title}
        </Typography>
        <Typography style={{ backgroundColor: "#181818", color: "white", textDecoration: "none" }} gutterBottom variant="h7">
          {props.contentRating}
        </Typography>
        <Typography style={{ backgroundColor: "#181818", color: "white", textDecoration: "none" }} color="text.secondary">{props.releaseDate}</Typography>
      </CardContent>
    </Card>
  );
};

export default VideoCard;
